import { useParams } from "react-router-dom"
import AdditionListView from "../../../partial/AdditionListView"
import ResponseCodeView from "../../../partial/ResponseCodeView"
import ResponseFileView from "../../../partial/ResponseFileView"
import ResponseTextView from "../../../partial/ResponseTextView"
import { useGetResponseByIdQuery } from "../../responses/responsesApiSlice"

const CurrentResponse = () => {
  const { responseId} = useParams()
  const {
    data: response,
    isLoading,
    isSuccess,
    isError,
    error
} = useGetResponseByIdQuery({id:responseId})
  const type = response.action?.type || "Text"
  return (<>
    <span className='grid-results-header'>
    <div className='sticky'> ביצוע</div>
      </span>
       
    <span className='grid-results-data'>
       
    <>
                {type==="Text"&& <ResponseTextView  body={response.body}  />}
                {type==="Code"&& <ResponseCodeView header={`${response.action?.title}-${response.action?.text}`} language={response.action?.language}  highlight={response.action?.highlight} body={response.body}  />}
                {type==="File"&& <ResponseFileView  body={response.body}  />}
              
            </>          
    </span>
    <AdditionListView additions={response.additions} type={type} />
    <span className='grid-results-header'> הערות משתמש </span>
        <span className='grid-results-data'>
        <textarea readOnly
                    className={`form__input  form__input--comments  comments-area`}
                    id="comments"
                    name="comments"
                    value={response.comments}
                    
                />        
            </span>
    </>
  )
}

export default CurrentResponse